import { ScholarshipTypeDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScholarshipTypeService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getScholarshipType(): Observable<ScholarshipTypeDto[]> {
    return this.http.get<ScholarshipTypeDto[]>(this.url + 'scholarship-type');
  }

  createScholarshipType(
    data: ScholarshipTypeDto[]
  ): Observable<ScholarshipTypeDto[]> {
    return this.http.post<ScholarshipTypeDto[]>(
      this.url + 'scholarship-type',
      data
    );
  }
  getSingleScholarshipType(id: string): Observable<any> {
    return this.http.get(this.url + 'scholarship-type/' + id);
  }

  updateScholarshipType(
    data: ScholarshipTypeDto[]
  ): Observable<ScholarshipTypeDto[]> {
    return this.http.post<ScholarshipTypeDto[]>(
      this.url + 'scholarship-type/update',
      data
    );
  }

  deleteScholarshipType(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('scholarship-type', ids.join(', '));
    return this.http.delete(this.url + 'scholarship-type', httpOptions);
  }
}
